import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostLimitDeletionFailedAction = {
	type: 'AI_COST_LIMIT_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostLimitDeletionFailedAction => ({
	type: 'AI_COST_LIMIT_DELETION_FAILED',
	payload,
});
